"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = WizardStep;

var _react = _interopRequireWildcard(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _GenericStore = require("../store/GenericStore");

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid/Grid"));

var _Component = _interopRequireDefault(require("../../render/Component"));

var _reactI18next = require("react-i18next");

var _Context = _interopRequireDefault(require("../../Context"));

var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));

var _styles = require("@material-ui/core/styles");

var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%'
    },
    button: {
      width: '90%',
      backgroundColor: '#FF9B39',
      color: 'white'
    },
    component: {
      padding: '20px',
      width: '100%'
    },
    bottom: {
      width: '100%',
      textAlign: 'center',
      marginTop: '30px',
      marginBottom: '20px'
    },
    body: {
      padding: '20px'
    },
    title: {
      fontFamily: 'FSMEWebBold',
      fontSize: '1.2em',
      fontWeight: '600',
      textAlign: 'center'
    }
  };
});

function WizardStep(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useContext = (0, _react.useContext)(_Context["default"]),
      onCancel = _useContext.onCancel,
      onNext = _useContext.onNext,
      getData = _useContext.getData;

  var block = props.block,
      parentPath = props.parentPath,
      onSubmit = props.onSubmit;
  var classes = useStyles();
  (0, _react.useEffect)(function () {});

  var handleSubmit = function handleSubmit() {
    var record = getData();
    /*
    let plainData = []
    record?.wizard?.step1?.userInput?.forEach(item => {
      plainData.push(item.value)
    })
    record?.wizard?.step1?.options?.value ? plainData = record?.wizard?.step1?.options?.value : null
    record.preconditionData = plainData
    */

    onSubmit(record);
  };

  var formComponents = block.content;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.body
  }, block.label && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.title
  }, t(block.label)), formComponents.map(function (component) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.component
    }, /*#__PURE__*/_react["default"].createElement(_Component["default"], {
      block: component,
      parentPath: parentPath,
      store: _GenericStore.dataStore,
      key: parentPath + component.path,
      isPreconditionData: block === null || block === void 0 ? void 0 : block.isPreconditionData
    }));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.bottom
  }, /*#__PURE__*/_react["default"].createElement(_Fab["default"], {
    variant: "extended",
    onClick: (block === null || block === void 0 ? void 0 : block.isFinal) ? handleSubmit : onNext.onNext,
    className: classes.button
  }, block.isFinal ? t('BTN_FINAL') : t('BTN_CONTINUE'))));
}